import { useEffect, useState } from 'react';
import { api } from '../api';
import PageHeader from '../components/PageHeader';
import StatusBadge from '../components/StatusBadge';

export default function Returns() {
  const [searchId, setSearchId] = useState('');
  const [order, setOrder] = useState(null);
  const [notes, setNotes] = useState('');
  const [returns, setReturns] = useState([]);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const loadReturns = () => api.getReturns().then(setReturns).catch((e) => setError(e.message));

  useEffect(() => {
    loadReturns();
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setOrder(null);
    try {
      const data = await api.getOrder(searchId);
      setOrder(data);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleReturn = async () => {
    try {
      await api.markReturned({ orderId: order.orderId, notes });
      setMessage(`Order #${order.orderId} marked as returned`);
      setOrder(null);
      setNotes('');
      setSearchId('');
      loadReturns();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <PageHeader title="Returns" subtitle="Search orders and manage returns" />
      <form onSubmit={handleSearch} className="card mb-6 flex gap-3 max-w-md">
        <input
          type="number"
          placeholder="Search Order ID"
          value={searchId}
          onChange={(e) => setSearchId(e.target.value)}
          className="input"
          required
        />
        <button type="submit" className="btn-primary whitespace-nowrap">
          View Order
        </button>
      </form>

      {error && <p className="text-red-600 mb-4">{error}</p>}
      {message && <p className="text-green-700 mb-4">{message}</p>}

      {order && (
        <div className="card mb-8">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-serif font-medium text-lumora-dark-wood">Order #{order.orderId}</h3>
            <StatusBadge status={order.status} />
          </div>
          <p className="text-sm text-lumora-text/60 mb-2">
            {order.date} at {order.time} — {order.customerName}
          </p>
          <ul className="mb-4 space-y-1">
            {order.items.map((item, i) => (
              <li key={i} className="text-sm">
                {item.productName} × {item.quantity}
              </li>
            ))}
          </ul>
          {order.status !== 'Returned' && (
            <>
              <textarea
                placeholder="Return notes..."
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                className="input mb-3"
                rows={3}
              />
              <button type="button" onClick={handleReturn} className="btn-danger">
                Mark as Returned
              </button>
            </>
          )}
        </div>
      )}

      <h3 className="font-serif font-medium text-lumora-dark-wood mb-4">Return History</h3>
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Order ID</th>
              <th>Date</th>
              <th>Notes</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {returns.map((r) => (
              <tr key={r.id}>
                <td>{r.id}</td>
                <td>#{r.orderId}</td>
                <td>{r.date}</td>
                <td>{r.notes}</td>
                <td>
                  <StatusBadge status={r.status} />
                </td>
              </tr>
            ))}
            {returns.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center text-lumora-text/50 py-8">
                  No returns recorded
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
